module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/additional-briefing-elite.fe543ccb.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/additional-briefing-elite.png
// module id = 3691
// module chunks = 11